import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BookingPassportsState {
    bookingRef: string;
    hasfilterApplied: boolean;

    apiCount: number;
}

const initialState: BookingPassportsState = {
    bookingRef: '',
    hasfilterApplied: false,
    apiCount: 0,
};

const bookingPassport = createSlice({
    name: 'bookingPassports',
    initialState,
    reducers: {
        setBookingRefFilter: (state, action: PayloadAction<string>) => {
            state.bookingRef = action.payload;
        },
        applybookingPassportFilter: (state) => {
            state.hasfilterApplied = true;
            state.apiCount += 1;
        },
        clearAllFilter: (state) => {
            state.hasfilterApplied = false;
            state.bookingRef = '';
            state.apiCount = 0;
        },
    },
});

export const { setBookingRefFilter, applybookingPassportFilter, clearAllFilter } = bookingPassport.actions;
export default bookingPassport.reducer;
